import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { childrenTexts } from 'consts/text';
import { createFieldValidationRules } from 'utils/formValidationHelpers';

export const BirthPlaceInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label={childrenTexts.childForm.personalData.birthPlace}
        name={formFields.birthPlace}
        rules={createFieldValidationRules('birthPlace', {
            required: true,
            maxLength: 300,
        })}
        accessibilityLabel={`Pole ${childrenTexts.childForm.personalData.birthPlace}`}
        {...props}
    >
        <AppInput
            autoComplete="off"
            accessibilityLabel={`Pole ${childrenTexts.childForm.personalData.birthPlace}`}
            placeholder="Podaj miejsce urodzenia"
        />
    </AppFormItem>
);
